import type { Channel } from '@/types'
import { microUsdToUsd, usdToMicroUsd } from './quota'

export type ChannelBalanceSource = 'none' | 'upstream' | 'manual' | 'estimated' | 'hybrid'
export type LowBalanceLevel = 'normal' | 'warning' | 'critical'

export const BALANCE_SOURCE_OPTIONS: { value: ChannelBalanceSource; label: string }[] = [
  { value: 'none', label: '不启用' },
  { value: 'upstream', label: '上游查询' },
  { value: 'manual', label: '手动维护' },
  { value: 'estimated', label: '平台估算' },
  { value: 'hybrid', label: '混合（取较低值）' },
]

export function getComparableBalanceMicroUsd(channel: Pick<Channel, 'balanceSource' | 'balance' | 'estimatedBalanceMicroUsd'>): number {
  const source = channel.balanceSource || 'upstream'
  switch (source) {
    case 'none':
      return 0
    case 'manual':
    case 'estimated':
      return channel.estimatedBalanceMicroUsd ?? 0
    case 'hybrid': {
      const upstream = usdToMicroUsd(channel.balance)
      const estimated = channel.estimatedBalanceMicroUsd ?? 0
      if (estimated <= 0) return upstream
      if (upstream <= 0) return estimated
      return Math.min(upstream, estimated)
    }
    default:
      return usdToMicroUsd(channel.balance)
  }
}

export function computeLowBalanceLevel(
  channel: Pick<
    Channel,
    | 'balanceAlertEnabled'
    | 'balanceSource'
    | 'balance'
    | 'estimatedBalanceMicroUsd'
    | 'balanceWarningThresholdMicroUsd'
    | 'balanceCriticalThresholdMicroUsd'
  >
): LowBalanceLevel {
  if (!channel.balanceAlertEnabled || channel.balanceSource === 'none') {
    return 'normal'
  }
  const balanceMicro = getComparableBalanceMicroUsd(channel)
  const critical = channel.balanceCriticalThresholdMicroUsd ?? 0
  const warning = channel.balanceWarningThresholdMicroUsd ?? 0
  if (critical > 0 && balanceMicro < critical) return 'critical'
  if (warning > 0 && balanceMicro < warning) return 'warning'
  return 'normal'
}

export function lowBalancePillVariant(level: LowBalanceLevel): 'warning' | 'danger' | null {
  if (level === 'warning') return 'warning'
  if (level === 'critical') return 'danger'
  return null
}

export { microUsdToUsd, usdToMicroUsd }
